<template>
  <div class="w-full">
    <label class="label" :for="label">
      {{ label }}
    </label>
    <input @blur="verifyAsyncCall" v-validate="validationRule" :name="field" :class="{'field': true, 'border-grey-lighter': !errors.has(field),'border-red': errors.has(field), 'field-disabled': disabled }" :id="label" type="email" :placeholder="placeholder" v-model="fieldModel" :disabled="disabled == 1">
    <p class="text-red text-xs italic mt-3" v-show="errors.has(field)">{{ validationMessage }}</p>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'FieldText',
  inject: ['$validator'],
  props: {
    namespace: {
      type: String,
    },
    field: {
      type: String,
    },
    async: {
      type: Boolean,
    },
    url: {
      type: String,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    },
    validationRule: {
      default: 'required|email',
    },
    validationMessage: {
      type: String,
      default: 'Please enter a valid email address',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async verifyAsyncCall() {
      if (!this.async) return;
      try {
        await this.$http.get(`broker/validate-broker-email?email=${this.fieldModel}`)
      } catch (e) {
        this.$toasted.error(
          `Error: ${(e.body && e.body.error) ||
          e.message ||
          'This email is taken'}`
        );
      }
    },
  },
  computed: {
    fieldModel: {
      get() {
        return _.get(this.$store.state[this.namespace], this.field);
      },
      set(value) {
        this.$store.commit(`${this.namespace}/setField`, {
          field: this.field,
          value,
        });
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FieldEmail.vue